(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    for (const element of document.querySelectorAll('details[data-auto-close-details][open]')) {
      if (
        element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
        !(event.target instanceof Node && element.contains(event.target))
      ) {
        element.removeAttribute('open');
      }
    }
  });
})();
